import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createAuthSlice, IAuthStore } from './auth';
import { createFormSlice, IFormStore } from './form';
import { createHintSlice, IHintStore } from './hint';
import { createLanguageSlice, ILanguageStore } from './languages';
import { createNavigationSlice, INavigationStore } from './navigation';
import { createRedirectSlice, IRedirectStore } from './redirect';
import { createSearchSlice, ISearchStore } from './search';
import { createTableSlice, ITableStore } from './table';
import { createThemeSlice, IThemeStore } from './theme';
import { createViewSlice, IViewStore } from './view';

export interface IAppStore
  extends
    IAuthStore,
    ITableStore,
    ISearchStore,
    IViewStore,
    ILanguageStore,
    IRedirectStore,
    INavigationStore,
    IThemeStore,
    IFormStore,
    IHintStore {}

export const appStore = create<IAppStore, [['zustand/persist', IAppStore]]>(
  persist(
    (...a) => ({
      ...createAuthSlice(...a),
      ...createTableSlice(...a),
      ...createSearchSlice(...a),
      ...createViewSlice(...a),
      ...createThemeSlice(...a),
      ...createLanguageSlice(...a),
      ...createRedirectSlice(...a),
      ...createNavigationSlice(...a),
      ...createFormSlice(...a),
      ...createHintSlice(...a),
    }),
    {
      name: 'client-web-store',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
